import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { BajaWizard } from '../components/psychologist/baja/BajaWizard';
import { profilePath } from '@/routes/slugs';

/**
 * "Quiero dejar de ser parte de Psi Mammoliti" — wizard de baja, nativo desde
 * acá (antes era un iframe a un proyecto Lovable aparte con su propia
 * Supabase + login Google; ver BajaWizard.tsx y psiplatform-be/src/modules/baja).
 * La identidad es la sesión real de la psicóloga, sin login ni link
 * compartible por email.
 */
export const FarewellEmbed: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <div className="mx-auto max-w-4xl px-4 pt-6 pb-16 sm:px-6">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => navigate(profilePath('metrics'))}
          className="mb-6 -ml-2"
        >
          <ArrowLeft className="h-4 w-4 mr-1" /> Volver
        </Button>

        <BajaWizard onExit={() => navigate(profilePath('metrics'))} />
      </div>
    </div>
  );
};

export default FarewellEmbed;
